import { render } from "./v-radio-group.vue?vue&type=template&id=4d4b4e76&scoped=true"
import script from "./v-radio-group.vue?vue&type=script&lang=js"
export * from "./v-radio-group.vue?vue&type=script&lang=js"

import "./v-radio-group.vue?vue&type=style&index=0&id=4d4b4e76&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d4b4e76"]])

export default __exports__